export default {
    "scalars": [
        0,
        1,
        3,
        10,
        13,
        36,
        56
    ],
    "types": {
        "String": {},
        "Int": {},
        "AggregationInput": {
            "value": [
                0
            ],
            "options": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "ID": {},
        "DIYProjectIndex": {
            "aggregations": [
                5
            ],
            "connection": [
                7
            ],
            "__typename": [
                0
            ]
        },
        "Aggregation": {
            "label": [
                0
            ],
            "value": [
                0
            ],
            "options": [
                6
            ],
            "__typename": [
                0
            ]
        },
        "AggregationOption": {
            "value": [
                0
            ],
            "label": [
                0
            ],
            "count": [
                1
            ],
            "__typename": [
                0
            ]
        },
        "DIYProjectConnection": {
            "edges": [
                8
            ],
            "pageInfo": [
                35
            ],
            "totalCount": [
                1
            ],
            "__typename": [
                0
            ]
        },
        "DIYProjectEdge": {
            "node": [
                9
            ],
            "cursor": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "DIYProject": {
            "version": [
                0
            ],
            "baseLanguage": [
                0
            ],
            "firstname": [
                0
            ],
            "keywords": [
                0
            ],
            "projectLevel": [
                10
            ],
            "images": [
                11
            ],
            "title": [
                0
            ],
            "urlKey": [
                0
            ],
            "customUrlKey": [
                0
            ],
            "content": [
                0
            ],
            "stepByStepGuide": [
                12
            ],
            "orderStars": [
                10
            ],
            "deliveryStars": [
                10
            ],
            "generalStars": [
                10
            ],
            "review": [
                0
            ],
            "colorCode": [
                0
            ],
            "tips": [
                0
            ],
            "metaTitle": [
                0
            ],
            "metaDescription": [
                0
            ],
            "metaKeywords": [
                0
            ],
            "translated": [
                13
            ],
            "active": [
                13
            ],
            "price": [
                10
            ],
            "shippingPrice": [
                10
            ],
            "isSalable": [
                13
            ],
            "hasRestpieces": [
                13
            ],
            "woodCategories": [
                14
            ],
            "woodTypes": [
                25
            ],
            "spaces": [
                25
            ],
            "endProducts": [
                25
            ],
            "diyType": [
                25
            ],
            "categoryBrands": [
                25
            ],
            "products": [
                17
            ],
            "styles": [
                25
            ],
            "famousDesigners": [
                25
            ],
            "knownFrom": [
                25
            ],
            "status": [
                0
            ],
            "highlightable": [
                13
            ],
            "cartHash": [
                0
            ],
            "projectCode": [
                0
            ],
            "wordpressPostId": [
                0
            ],
            "shortUrl": [
                34
            ],
            "urlIdentifier": [
                0
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "url": [
                0
            ],
            "hreflang": [
                24
            ],
            "__typename": [
                0
            ]
        },
        "Float": {},
        "Image": {
            "id": [
                3
            ],
            "fullpath": [
                0
            ],
            "filename": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "StepByStepGuide": {
            "stepDescription": [
                0
            ],
            "phase": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "Boolean": {},
        "Category": {
            "enabled": [
                13
            ],
            "name": [
                0
            ],
            "urlKey": [
                0
            ],
            "description": [
                0
            ],
            "metaTitle": [
                0
            ],
            "metaDescription": [
                0
            ],
            "metaKeywords": [
                0
            ],
            "image": [
                11
            ],
            "urlIdentifier": [
                0
            ],
            "isUsedForSeo": [
                0
            ],
            "displayType": [
                0
            ],
            "blocks": [
                15
            ],
            "showFilters": [
                13
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "url": [
                0
            ],
            "hreflang": [
                24
            ],
            "__typename": [
                0
            ]
        },
        "CategorySeoBlock": {
            "title": [
                0
            ],
            "content": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "Children": {
            "on_Product": [
                17
            ],
            "on_Sheet": [
                33
            ],
            "on_Category": [
                14
            ],
            "on_Page": [
                20
            ],
            "on_FaqItem": [
                23
            ],
            "on_FaqCategory": [
                22
            ],
            "on_Stylist": [
                26
            ],
            "on_DIYProject": [
                9
            ],
            "on_BlogCategory": [
                25
            ],
            "__typename": [
                0
            ]
        },
        "Product": {
            "name": [
                0
            ],
            "description": [
                0
            ],
            "shortDescription": [
                0
            ],
            "status": [
                0
            ],
            "urlkey": [
                0
            ],
            "customUrlKey": [
                0
            ],
            "categoryLabel": [
                0
            ],
            "visibility": [
                0
            ],
            "calculatedPrice": [
                0
            ],
            "fixedPrice": [
                10
            ],
            "taxClass": [
                18
            ],
            "weightFee": [
                10
            ],
            "yukiLedgerAccount": [
                0
            ],
            "stockMessage": [
                0
            ],
            "hsCode": [
                10
            ],
            "hsCodeUnit": [
                0
            ],
            "youtubeUrl": [
                0
            ],
            "metaTitle": [
                0
            ],
            "metaDescription": [
                0
            ],
            "metaKeywords": [
                0
            ],
            "specsheet": [
                28
            ],
            "ean": [
                0
            ],
            "sku": [
                0
            ],
            "urlIdentifier": [
                0
            ],
            "attributeSet": [
                0
            ],
            "typeId": [
                0
            ],
            "color": [
                0
            ],
            "weight": [
                10
            ],
            "brand": [
                0
            ],
            "customJsonConfiguration": [
                0
            ],
            "diyProjectCode": [
                0
            ],
            "sampleService": [
                0
            ],
            "priceType": [
                0
            ],
            "cost": [
                10
            ],
            "margin": [
                10
            ],
            "minimalPrice": [
                10
            ],
            "minimalPriceCompletePanel": [
                10
            ],
            "minimalPriceThreshold": [
                10
            ],
            "quantityIncrements": [
                10
            ],
            "isInStock": [
                13
            ],
            "alternativeProduct": [
                17
            ],
            "stockPosition": [
                0
            ],
            "deliveryOffset": [
                10
            ],
            "image": [
                11
            ],
            "detailImage": [
                11
            ],
            "gallery": [
                11
            ],
            "sheetTypeBase": [
                0
            ],
            "sheetTypeFinish": [
                0
            ],
            "sheetShapes": [
                30
            ],
            "sheetFinishes": [
                31
            ],
            "sheetMandatoryFinishes": [
                31
            ],
            "sheetAvailableAbsBandColors": [
                0
            ],
            "sheetPurchaseType": [
                0
            ],
            "sheetThickness": [
                10
            ],
            "sheetUnit": [
                0
            ],
            "sheetMinLength": [
                10
            ],
            "sheetMinWidth": [
                10
            ],
            "sheetOutdoor": [
                0
            ],
            "sheetPrimed": [
                13
            ],
            "sheetWaterResistant": [
                13
            ],
            "sheetHasVisibleSide": [
                13
            ],
            "sheetFingerprintProof": [
                13
            ],
            "sheetColorCode": [
                0
            ],
            "sheetWoodQualityMark": [
                0
            ],
            "sheetGrainType": [
                0
            ],
            "sheetToplayerSides": [
                0
            ],
            "sheetToplayerType": [
                0
            ],
            "sheetTreatmentForUse": [
                0
            ],
            "sheetQualityVisual": [
                0
            ],
            "sheetAppearance": [
                0
            ],
            "sheetWoodStructure": [
                0
            ],
            "sheetWoodUsed": [
                0
            ],
            "sheetDecorative": [
                0
            ],
            "sheetConnectionType": [
                0
            ],
            "sheetSustainability": [
                0
            ],
            "sheetDensity": [
                0
            ],
            "sheetFormaldehydeReleaseClass": [
                0
            ],
            "sheetGlue": [
                0
            ],
            "sheetFireResistant": [
                0
            ],
            "sheetConditionAgreement": [
                0
            ],
            "sheetConditionAgreementText": [
                0
            ],
            "sheetPositiveNegative": [
                0
            ],
            "sheetWoodApplications": [
                0
            ],
            "sheetApplyBeltSize": [
                0
            ],
            "sheetVeneerThickness": [
                10
            ],
            "sheetVeneerCuttingMethod": [
                0
            ],
            "sheetWeightPerM3": [
                10
            ],
            "sheetJointingTechnique": [
                0
            ],
            "sheetNcsColorCode": [
                0
            ],
            "sheetGeneralApplication": [
                0
            ],
            "sheetPaintability": [
                0
            ],
            "sheetCore": [
                0
            ],
            "sheetColorShade": [
                0
            ],
            "sheetAlternativeOptiplanning": [
                0
            ],
            "sheetProductionType": [
                0
            ],
            "sheetProductionUnit": [
                0
            ],
            "sheetWorkSpeed": [
                0
            ],
            "sheetReverseMillingDirection": [
                13
            ],
            "sheetPreMill": [
                13
            ],
            "sheetTroughMill": [
                13
            ],
            "sheetExcludeForCncProduction": [
                0
            ],
            "sheetMinimumMiter": [
                10
            ],
            "sheetMaximumMiter": [
                10
            ],
            "sheetMinimumChamfering": [
                10
            ],
            "sheetMaximumChamfering": [
                10
            ],
            "sheetMinimumCompletion": [
                10
            ],
            "sheetMaximumCompletion": [
                10
            ],
            "sheetMinimumHollowprofile": [
                10
            ],
            "sheetMaximimumHollowProfile": [
                10
            ],
            "sheetMinimumQuarterRound": [
                10
            ],
            "sheetMaximumQuarterRound": [
                10
            ],
            "sheetDeliveryTime": [
                0
            ],
            "accessoriesLength": [
                10
            ],
            "accessoriesWidth": [
                10
            ],
            "accessoriesHeight": [
                10
            ],
            "accessoriesDiameter": [
                0
            ],
            "accessoriesBitType": [
                0
            ],
            "accessoriesPackagingContent": [
                10
            ],
            "accessoriesColorCode": [
                0
            ],
            "cabinetOuterWidth": [
                0
            ],
            "cabinetOuterHeight": [
                0
            ],
            "cabinetOuterDepth": [
                0
            ],
            "plasticSoundDamping": [
                10
            ],
            "plasticLightTransmission": [
                0
            ],
            "plasticUvResistant": [
                0
            ],
            "plasticAcrylaatType": [
                0
            ],
            "plasticWarranty": [
                0
            ],
            "plasticDensityGrCm3": [
                10
            ],
            "plasticTensileNewtonMm2": [
                10
            ],
            "plasticElasticyModulusNewtonMm2": [
                10
            ],
            "plasticBuigsterkteNewtonMm2": [
                10
            ],
            "plasticCompresResistanceNewtonMm2": [
                10
            ],
            "plasticHardnessShore": [
                0
            ],
            "plasticFrictionCoefficient": [
                10
            ],
            "plasticTemperatureMinUnloaded": [
                10
            ],
            "plasticTemperatureMaxUnloaded": [
                10
            ],
            "plasticLinearExpansionCoefficient": [
                10
            ],
            "plasticRelativeDielectricConstant": [
                0
            ],
            "plasticDielectricLossFactor": [
                0
            ],
            "plasticResistanceSpecific": [
                0
            ],
            "plasticResistanceSurface": [
                0
            ],
            "plasticBreakdownVoltage": [
                0
            ],
            "threedimensionalTopTexture": [
                11
            ],
            "threedimensionalSideTexture": [
                11
            ],
            "categories": [
                14
            ],
            "faqCategories": [
                22
            ],
            "crossSells": [
                17
            ],
            "upSells": [
                17
            ],
            "relatedProducts": [
                17
            ],
            "edgeBands": [
                32
            ],
            "sample": [
                17
            ],
            "tosizeFurnitureDecor": [
                0
            ],
            "supplier": [
                0
            ],
            "supplierSku": [
                0
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "url": [
                0
            ],
            "hreflang": [
                24
            ],
            "__typename": [
                0
            ]
        },
        "Tax": {
            "name": [
                0
            ],
            "percentage": [
                10
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "__typename": [
                0
            ]
        },
        "Parent": {
            "on_Product": [
                17
            ],
            "on_Category": [
                14
            ],
            "on_Page": [
                20
            ],
            "on_FaqItem": [
                23
            ],
            "on_FaqCategory": [
                22
            ],
            "on_Stylist": [
                26
            ],
            "__typename": [
                0
            ]
        },
        "Page": {
            "enabled": [
                0
            ],
            "title": [
                0
            ],
            "urlKey": [
                0
            ],
            "customUrlKey": [
                0
            ],
            "content": [
                0
            ],
            "intro": [
                0
            ],
            "image": [
                11
            ],
            "metaTitle": [
                0
            ],
            "metaDescription": [
                0
            ],
            "includeInSitemap": [
                0
            ],
            "pageRelation": [
                21
            ],
            "blogCategory": [
                25
            ],
            "urlIdentifier": [
                0
            ],
            "pageType": [
                0
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "url": [
                0
            ],
            "hreflang": [
                24
            ],
            "__typename": [
                0
            ]
        },
        "pageRelationUnion": {
            "on_FaqCategory": [
                22
            ],
            "on_FaqItem": [
                23
            ],
            "on_Page": [
                20
            ],
            "__typename": [
                0
            ]
        },
        "FaqCategory": {
            "enabled": [
                13
            ],
            "title": [
                0
            ],
            "faqItems": [
                23
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "__typename": [
                0
            ]
        },
        "FaqItem": {
            "title": [
                0
            ],
            "content": [
                0
            ],
            "enabled": [
                13
            ],
            "urlKey": [
                0
            ],
            "customUrlKey": [
                0
            ],
            "metaTitle": [
                0
            ],
            "metaDescription": [
                0
            ],
            "urlIdentifier": [
                0
            ],
            "image": [
                11
            ],
            "imagePosition": [
                0
            ],
            "imageSize": [
                0
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "url": [
                0
            ],
            "hreflang": [
                24
            ],
            "__typename": [
                0
            ]
        },
        "Hreflang": {
            "href": [
                0
            ],
            "hreflang": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "BlogCategory": {
            "name": [
                0
            ],
            "urlKey": [
                0
            ],
            "customUrlKey": [
                0
            ],
            "description": [
                0
            ],
            "showInMenu": [
                13
            ],
            "enabled": [
                0
            ],
            "image": [
                11
            ],
            "metaTitle": [
                0
            ],
            "metaDescription": [
                0
            ],
            "metaKeywords": [
                0
            ],
            "urlIdentifier": [
                0
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "url": [
                0
            ],
            "hreflang": [
                24
            ],
            "__typename": [
                0
            ]
        },
        "Stylist": {
            "enabled": [
                0
            ],
            "title": [
                0
            ],
            "urlKey": [
                0
            ],
            "customUrlKey": [
                0
            ],
            "personalTitle": [
                0
            ],
            "content": [
                0
            ],
            "speciality": [
                0
            ],
            "formTitle": [
                0
            ],
            "formContent": [
                0
            ],
            "metaTitle": [
                0
            ],
            "metaDescription": [
                0
            ],
            "metaKeywords": [
                0
            ],
            "gallery": [
                11
            ],
            "personalImage": [
                11
            ],
            "personalImageClose": [
                11
            ],
            "name": [
                0
            ],
            "email": [
                0
            ],
            "companyName": [
                0
            ],
            "location": [
                0
            ],
            "website": [
                27
            ],
            "latlng": [
                0
            ],
            "youtube": [
                0
            ],
            "facebook": [
                0
            ],
            "instagram": [
                0
            ],
            "pinterest": [
                0
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "url": [
                0
            ],
            "hreflang": [
                24
            ],
            "__typename": [
                0
            ]
        },
        "Link": {
            "html": [
                0
            ],
            "class": [
                0
            ],
            "title": [
                0
            ],
            "path": [
                0
            ],
            "accessKey": [
                0
            ],
            "anchor": [
                0
            ],
            "attributes": [
                0
            ],
            "href": [
                0
            ],
            "rel": [
                0
            ],
            "tabindex": [
                0
            ],
            "target": [
                0
            ],
            "text": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "ElementMetaDataSpecsheet": {
            "element": [
                29
            ],
            "variant": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "Asset": {
            "id": [
                3
            ],
            "fullpath": [
                0
            ],
            "filename": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "Shape": {
            "code": [
                0
            ],
            "enabled": [
                13
            ],
            "name": [
                0
            ],
            "description": [
                0
            ],
            "categoryUrl": [
                0
            ],
            "sortOrder": [
                10
            ],
            "maxLength": [
                10
            ],
            "maxWidth": [
                10
            ],
            "price": [
                10
            ],
            "image3d": [
                11
            ],
            "image2d": [
                11
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "__typename": [
                0
            ]
        },
        "Finish": {
            "code": [
                0
            ],
            "name": [
                0
            ],
            "description": [
                0
            ],
            "shapeEnabled": [
                13
            ],
            "categoryUrl": [
                0
            ],
            "disallowedShapes": [
                30
            ],
            "price": [
                10
            ],
            "image2d": [
                11
            ],
            "image3d": [
                11
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "__typename": [
                0
            ]
        },
        "EdgeBand": {
            "name": [
                0
            ],
            "enabled": [
                13
            ],
            "price": [
                0
            ],
            "fixedPrice": [
                10
            ],
            "taxClass": [
                18
            ],
            "width": [
                10
            ],
            "thickness": [
                10
            ],
            "stockPosition": [
                0
            ],
            "cuttable": [
                13
            ],
            "image": [
                11
            ],
            "material": [
                0
            ],
            "decor": [
                0
            ],
            "surface": [
                0
            ],
            "color": [
                0
            ],
            "priceType": [
                0
            ],
            "cost": [
                10
            ],
            "margin": [
                10
            ],
            "productType": [
                0
            ],
            "sku": [
                0
            ],
            "minOrderLength": [
                10
            ],
            "articleId": [
                0
            ],
            "productId": [
                0
            ],
            "url": [
                0
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "__typename": [
                0
            ]
        },
        "Sheet": {
            "isActive": [
                13
            ],
            "isDefault": [
                13
            ],
            "brand": [
                0
            ],
            "stockPosition": [
                0
            ],
            "productionUnit": [
                0
            ],
            "product": [
                17
            ],
            "priceType": [
                0
            ],
            "cost": [
                10
            ],
            "margin": [
                10
            ],
            "marginCompletePanel": [
                10
            ],
            "calculatedPrice": [
                0
            ],
            "calculatedPriceM2CompletePanel": [
                0
            ],
            "fixedPrice": [
                10
            ],
            "taxClass": [
                18
            ],
            "weightFee": [
                10
            ],
            "supplier": [
                0
            ],
            "supplierProductName": [
                0
            ],
            "supplierSku": [
                0
            ],
            "supplierProductUrl": [
                0
            ],
            "manufacturerProductUrl": [
                0
            ],
            "length": [
                10
            ],
            "width": [
                10
            ],
            "thickness": [
                10
            ],
            "weight": [
                10
            ],
            "deliveryOffset": [
                10
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "__typename": [
                0
            ]
        },
        "ShortUrl": {
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "__typename": [
                0
            ]
        },
        "PageInfo": {
            "hasNextPage": [
                13
            ],
            "hasPreviousPage": [
                13
            ],
            "startCursor": [
                0
            ],
            "endCursor": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "SortOrder": {},
        "StylistConnection": {
            "edges": [
                38
            ],
            "pageInfo": [
                35
            ],
            "totalCount": [
                1
            ],
            "__typename": [
                0
            ]
        },
        "StylistEdge": {
            "node": [
                26
            ],
            "cursor": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "BlogCategoryConnection": {
            "edges": [
                40
            ],
            "pageInfo": [
                35
            ],
            "totalCount": [
                1
            ],
            "__typename": [
                0
            ]
        },
        "BlogCategoryEdge": {
            "node": [
                25
            ],
            "cursor": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "FaqItemConnection": {
            "edges": [
                42
            ],
            "pageInfo": [
                35
            ],
            "totalCount": [
                1
            ],
            "__typename": [
                0
            ]
        },
        "FaqItemEdge": {
            "node": [
                23
            ],
            "cursor": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "FaqCategoryConnection": {
            "edges": [
                44
            ],
            "pageInfo": [
                35
            ],
            "totalCount": [
                1
            ],
            "__typename": [
                0
            ]
        },
        "FaqCategoryEdge": {
            "node": [
                22
            ],
            "cursor": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "PageConnection": {
            "edges": [
                46
            ],
            "pageInfo": [
                35
            ],
            "totalCount": [
                1
            ],
            "__typename": [
                0
            ]
        },
        "PageEdge": {
            "node": [
                20
            ],
            "cursor": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "AttributeDescription": {
            "attributeCode": [
                0
            ],
            "title": [
                0
            ],
            "description": [
                0
            ],
            "id": [
                3
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "__typename": [
                0
            ]
        },
        "AttributeDescriptionConnection": {
            "edges": [
                49
            ],
            "pageInfo": [
                35
            ],
            "totalCount": [
                1
            ],
            "__typename": [
                0
            ]
        },
        "AttributeDescriptionEdge": {
            "node": [
                47
            ],
            "cursor": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "Index": {
            "name": [
                0
            ],
            "code": [
                0
            ],
            "items": [
                16
            ],
            "__typename": [
                0
            ]
        },
        "PublicEdgeBand": {
            "id": [
                3
            ],
            "name": [
                0
            ],
            "price": [
                0
            ],
            "width": [
                10
            ],
            "thickness": [
                10
            ],
            "cuttable": [
                13
            ],
            "image": [
                11
            ],
            "material": [
                0
            ],
            "decor": [
                0
            ],
            "surface": [
                0
            ],
            "color": [
                0
            ],
            "sku": [
                0
            ],
            "minOrderLength": [
                10
            ],
            "children": [
                16
            ],
            "parent": [
                19
            ],
            "parentId": [
                3
            ],
            "__typename": [
                0
            ]
        },
        "PublicEdgeBandIndexType": {
            "aggregations": [
                5
            ],
            "available": [
                53
            ],
            "matching": [
                51
            ],
            "__typename": [
                0
            ]
        },
        "PublicEdgeBandConnection": {
            "pageInfo": [
                35
            ],
            "totalCount": [
                1
            ],
            "edges": [
                54
            ],
            "__typename": [
                0
            ]
        },
        "PublicEdgeBandEdge": {
            "node": [
                51
            ],
            "cursor": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "SubmitAIProjectInput": {
            "hash": [
                0
            ],
            "firstname": [
                0
            ],
            "keywords": [
                0
            ],
            "level": [
                1
            ],
            "images": [
                56
            ],
            "colorCode": [
                0
            ],
            "tips": [
                0
            ],
            "orderStars": [
                1
            ],
            "deliveryStars": [
                1
            ],
            "generalStars": [
                1
            ],
            "review": [
                0
            ],
            "stepByStepGuide": [
                57
            ],
            "__typename": [
                0
            ]
        },
        "Upload": {},
        "StepByStepGuideInput": {
            "stepDescription": [
                0
            ],
            "phase": [
                0
            ],
            "__typename": [
                0
            ]
        },
        "SubmitAIProjectResult": {
            "project": [
                9
            ],
            "__typename": [
                0
            ]
        },
        "Query": {
            "getDIYProjectIndexListing": [
                4,
                {
                    "after": [
                        0
                    ],
                    "first": [
                        1
                    ],
                    "before": [
                        0
                    ],
                    "last": [
                        1
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ],
                    "filter": [
                        2,
                        "[AggregationInput!]"
                    ],
                    "query": [
                        0
                    ],
                    "category": [
                        3
                    ]
                }
            ],
            "getStylist": [
                26,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "getStylistListing": [
                37,
                {
                    "after": [
                        0
                    ],
                    "first": [
                        1
                    ],
                    "before": [
                        0
                    ],
                    "last": [
                        1
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ],
                    "sortBy": [
                        0
                    ],
                    "sortOrder": [
                        36
                    ],
                    "filter": [
                        0
                    ]
                }
            ],
            "getDIYProject": [
                9,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "getDIYProjectListing": [
                7,
                {
                    "after": [
                        0
                    ],
                    "first": [
                        1
                    ],
                    "before": [
                        0
                    ],
                    "last": [
                        1
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ],
                    "sortBy": [
                        0
                    ],
                    "sortOrder": [
                        36
                    ],
                    "filter": [
                        0
                    ]
                }
            ],
            "getBlogCategory": [
                25,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "getBlogCategoryListing": [
                39,
                {
                    "after": [
                        0
                    ],
                    "first": [
                        1
                    ],
                    "before": [
                        0
                    ],
                    "last": [
                        1
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ],
                    "sortBy": [
                        0
                    ],
                    "sortOrder": [
                        36
                    ],
                    "filter": [
                        0
                    ]
                }
            ],
            "getFaqItem": [
                23,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "getFaqItemListing": [
                41,
                {
                    "after": [
                        0
                    ],
                    "first": [
                        1
                    ],
                    "before": [
                        0
                    ],
                    "last": [
                        1
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ],
                    "sortBy": [
                        0
                    ],
                    "sortOrder": [
                        36
                    ],
                    "filter": [
                        0
                    ]
                }
            ],
            "getFaqCategory": [
                22,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "getFaqCategoryListing": [
                43,
                {
                    "after": [
                        0
                    ],
                    "first": [
                        1
                    ],
                    "before": [
                        0
                    ],
                    "last": [
                        1
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ],
                    "sortBy": [
                        0
                    ],
                    "sortOrder": [
                        36
                    ],
                    "filter": [
                        0
                    ]
                }
            ],
            "getPage": [
                20,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "getPageListing": [
                45,
                {
                    "after": [
                        0
                    ],
                    "first": [
                        1
                    ],
                    "before": [
                        0
                    ],
                    "last": [
                        1
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ],
                    "sortBy": [
                        0
                    ],
                    "sortOrder": [
                        36
                    ],
                    "filter": [
                        0
                    ]
                }
            ],
            "getAttributeDescription": [
                47,
                {
                    "id": [
                        3,
                        "ID!"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "getAttributeDescriptionListing": [
                48,
                {
                    "after": [
                        0
                    ],
                    "first": [
                        1
                    ],
                    "before": [
                        0
                    ],
                    "last": [
                        1
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ],
                    "sortBy": [
                        0
                    ],
                    "sortOrder": [
                        36
                    ],
                    "filter": [
                        0
                    ]
                }
            ],
            "miniSearch": [
                50,
                {
                    "query": [
                        0,
                        "String!"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "DIYProjectForm": [
                9,
                {
                    "hash": [
                        0,
                        "String!"
                    ]
                }
            ],
            "relatedDiyProjects": [
                7,
                {
                    "after": [
                        0
                    ],
                    "first": [
                        1
                    ],
                    "before": [
                        0
                    ],
                    "last": [
                        1
                    ],
                    "sku": [
                        0,
                        "String!"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "edgeBandQuery": [
                51,
                {
                    "sku": [
                        0,
                        "String!"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "edgeBandsQuery": [
                52,
                {
                    "after": [
                        0
                    ],
                    "first": [
                        1
                    ],
                    "before": [
                        0
                    ],
                    "last": [
                        1
                    ],
                    "sku": [
                        0,
                        "String!"
                    ],
                    "query": [
                        0
                    ],
                    "filter": [
                        2,
                        "[AggregationInput!]"
                    ],
                    "defaultLanguage": [
                        0,
                        "String!"
                    ]
                }
            ],
            "ping": [
                0,
                {
                    "message": [
                        0,
                        "String!"
                    ]
                }
            ],
            "__typename": [
                0
            ]
        },
        "Mutation": {
            "submitAIProject": [
                58,
                {
                    "input": [
                        55,
                        "SubmitAIProjectInput!"
                    ]
                }
            ],
            "__typename": [
                0
            ]
        }
    }
}